/**
 * Tradução dos nomes das colunas da tabela Vehicles (API) para português (exibição no front).
 * Chave = nome da coluna na API; valor = label em português para o usuário.
 */
export const VEHICLE_EXPORT_COLUMN_LABELS: Record<string, string> = {
  Id: 'ID',
  PlateNumber: 'Placa',
  ChassisNumber: 'Chassi',
  Brand: 'Marca',
  Model: 'Modelo',
  ModelYear: 'Ano do Modelo',
  ManufactureYear: 'Ano de Fabricação',
  Color: 'Cor',
  FuelType: 'Tipo de Combustível',
  OwnershipType: 'Tipo de Propriedade',
  PurchaseDate: 'Data de Compra',
  PurchasePrice: 'Preço de Compra',
  Status: 'Status',
  CurrentLocation: 'Localização Atual',
  CurrentMileage: 'Quilometragem Atual',
  NextMaintenanceDate: 'Próxima Manutenção',
  RequiresMaintenance: 'Requer Manutenção',
  AssignedDriverName: 'Motorista Atribuído',
  Notes: 'Observações',
  HasBox: 'Possui Baú',
  HasPhoneSupport: 'Suporte para Celular',
  RenavamNumber: 'Renavam'
};
